import { render, staticRenderFns } from "./PolandStats.vue?vue&type=template&id=0fa71156&scoped=true&"
import script from "./PolandStats.vue?vue&type=script&lang=js&"
export * from "./PolandStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa71156",
  null
  
)

export default component.exports